import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import uuid from 'react-uuid';
import { useSelector } from 'react-redux';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import TicketTransactionAdd from '../../transactions/ticketTransaction/TicketTransactionAdd';

const CreateTicketModal                  =   forwardRef((props, ref) => {
    const createTicketModalElem                      =   useRef(null);
    const createTicketModal                          =   useRef(null);
    const createTicketModalOpen                      =   ()  => createTicketModal.current && createTicketModal.current.show()
    const createTicketModalClose                     =   ()  => createTicketModal.current && createTicketModal.current.hide()
    
    useEffect(() => {
        createTicketModalElem.current                =   document.getElementById(createTicketModalId);
        createTicketModal.current                    =   new Modal(createTicketModalElem.current, {keyboard: false, backdrop :false});
        return () => {
            createTicketModal.current && createTicketModal.current.dispose();
        };
    }, []);

    const [createTicketModalId, setCreateTicketModalId]          =   useState(uuid());
    const [createdTicket, setCreatedTicket] = useState(null);
    const [formData, setFormData] = useState({
        asset: {
            display_label :"",
            value :"",
            site_id:""
        },
        employee: null,
        workstation: null,
        subAssembly: null,
        demand_for: null,
        warehouse_site_ids:[],
    });

    useImperativeHandle(ref, () => ({
        initModalHandler: (data) => {
            setFormData(data);
            createTicketModalOpen();
        },
    }));


    const handleTicketCreated = (ticketData) => {
        setCreatedTicket(ticketData);
        createTicketModalClose();
        if (props.onTicketCreated) {
            props.onTicketCreated(ticketData);
        }
    };
    return <>
         <div className="modal fade" id={createTicketModalId} tabIndex="-1" ref={createTicketModalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                          Create Ticket
                        </h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div className="modal-body py-0">
                        <TicketTransactionAdd
                            createFromDemand={true}
                            type="itemDemand"
                            value={formData}
                            site_ids={formData.warehouse_site_ids}
                            onTicketCreated={handleTicketCreated}
                        />
                    </div>
                    {/* <div className="border-top p-2">
                            <div className=' text-end'>
                                <button type="button"  className="btn btn-secondary me-2" onClick={createTicketModalClose}>Close</button>
                                <button form={createTicketModalId + 'Form'}  type="submit" className="btn btn-primary">Save</button>
                            </div>
                    </div> */}
                </div>
            </div>  
        </div>
    </>
});

export default CreateTicketModal;